export default __webpack_public_path__ + "static/media/github-logo.0d075792.svg";